import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import AuditDetails from '../../elements/service/AuditDetails';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import PdfForm from '../../components/others/PdfForm';



const Pdf = () => {
    return (
        <>
            <SEO title="Audit and Accelerate Your Life, Business & Income" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Audit Details Page */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 w-75 mx-auto">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    // subtitle="Audit and Accelerate Your Life, Business & Income"
                                    title='Download Free E-Book'
                                // description = 
                                />
                                <PdfForm/>
                            </div>
                        </div>
                        

                    </div>
                </div>


                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Pdf
